import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import { Routes } from "./routes";
import { RouteProgress } from "./shared/ui-kit/RouteProgress";
import { CookieBanner } from "./areas/lgpd/CookieBanner";

export default function App() {
  return (
    <>
      <RouteProgress />
      <Suspense fallback={<RouteProgress active />}>
        <Routes />
      </Suspense>
      <CookieBanner />
      <Outlet />
    </>
  );
}
